const glossaryData = [
  {
    id: "letter-a",
    letter: "A",
    terms: [
      { term: "Address", definition: "A string of alphanumeric characters representing a possible payment destination. Only someone with the corresponding private key can access the cryptocurrency transferred there." },
      { term: "Address Format", definition: "The structure of a Bitcoin address, such as legacy (starting with ‘1’), SegWit (‘bc1’), or P2SH (‘3’), determining compatibility and features." },
      { term: "Address Reuse", definition: "The practice of using the same Bitcoin address for multiple transactions, discouraged due to reduced privacy and increased traceability." },
      { term: "Airdrop", definition: "A distribution of new cryptocurrency, often following a hard fork, typically considered taxable income when received by users." },
      { term: "Altcoin", definition: "Any cryptocurrency other than Bitcoin, each with unique features and use cases." },
      { term: "Anonymity Set", definition: "The group of possible senders in a privacy-focused transaction (e.g., CoinJoin), where a larger set enhances user privacy." },
      { term: "ASIC", definition: "Application-Specific Integrated Circuit. Specialized hardware designed for mining cryptocurrencies like Bitcoin." },
      { term: "Atomic Swap", definition: "A trustless exchange of Bitcoin for another cryptocurrency using smart contracts, enabling cross-chain trading without intermediaries." }
    ]
  },
  {
    id: "letter-b",
    letter: "B",
    terms: [
      { term: "Base Layer", definition: "The main Bitcoin blockchain, handling core transactions and consensus, distinct from layer-2 solutions like the Lightning Network." },
      { term: "Bitcoin", definition: "The first decentralized cryptocurrency, created in 2009 by Satoshi Nakamoto, operating on a peer-to-peer network without central authority." },
      { term: "Bitcoin ATM", definition: "A kiosk allowing users to buy or sell Bitcoin using cash or cards, often requiring KYC verification." },
      { term: "Bitcoin ETF", definition: "An exchange-traded fund holding Bitcoin or Bitcoin futures, allowing investors to gain exposure without directly owning the cryptocurrency." },
      { term: "Bitcoin Improvement Proposal (BIP)", definition: "A formal proposal to improve Bitcoin’s protocol, submitted by developers to suggest new features, fixes, or consensus changes." },
      { term: "Block", definition: "A set of transactions prefaced by a block header and secured by proof of work, forming the data stored on the blockchain." },
      { term: "Block Header", definition: "A section of a Bitcoin block containing metadata like the previous block hash, Merkle root, timestamp, nonce, and difficulty target." },
      { term: "Block Height", definition: "The number of blocks preceding a particular block on a blockchain, starting from the genesis block at height zero." },
      { term: "Block Reward", definition: "New bitcoins awarded to miners for adding a valid block to the blockchain." },
      { term: "Block Subsidy", definition: "The newly minted bitcoins awarded to miners as part of the block reward, currently 3.125 BTC post-2024 halving." },
      { term: "Blockchain", definition: "A decentralized ledger recording transactions across many computers, with each block containing a cryptographic hash of the previous block." },
      { term: "BTC", definition: "The ticker symbol for Bitcoin, used on exchanges and in financial contexts to represent the cryptocurrency." }
    ]
  },
  {
    id: "letter-c",
    letter: "C",
    terms: [
      { term: "Capital Gains Tax", definition: "A tax on profits from selling or exchanging Bitcoin, treated as property in jurisdictions like the US." },
      { term: "Chain Analysis", definition: "The process of analyzing Bitcoin’s blockchain to trace transactions, often used by regulators to identify illicit activity." },
      { term: "Chain Code", definition: "In HD wallets, 256 bits of entropy added to keys to generate secure child keys." },
      { term: "Child Pays for Parent (CPFP)", definition: "A technique where a high-fee transaction spends an unconfirmed low-fee transaction’s output to incentivize miner confirmation." },
      { term: "Coinbase", definition: "A field in coinbase transactions used to claim the block reward and store arbitrary data." },
      { term: "Coinbase Transaction", definition: "The first transaction in a Bitcoin block, used to pay miners the block reward and fees, distinct from the Coinbase exchange." },
      { term: "Cold Storage", definition: "Storing Bitcoin private keys offline, such as on a hardware wallet or paper, to protect against online threats." },
      { term: "Confirmation", definition: "The number of blocks added after a transaction, indicating its security level." },
      { term: "Consensus Rules", definition: "The set of rules all Bitcoin nodes follow to validate transactions and blocks, ensuring network agreement." },
      { term: "Crypto Exchange", definition: "A platform for trading Bitcoin and other cryptocurrencies, facilitating fiat-to-crypto and crypto-to-crypto transactions, often regulated." },
      { term: "Cryptocurrency", definition: "A digital currency secured by cryptography, resistant to counterfeiting or double-spending." },
      { term: "Cypherpunk", definition: "A movement advocating for privacy-enhancing technologies and cryptography to promote freedom." }
    ]
  },
  {
    id: "letter-d",
    letter: "D",
    terms: [
      { term: "Decentralized", definition: "A system where control is distributed among network participants, not held by a single entity." },
      { term: "Deterministic Wallet", definition: "A wallet generating all private keys from a single seed phrase, simplifying backups and recovery." },
      { term: "Difficulty Adjustment", definition: "Bitcoin’s mechanism to adjust mining difficulty every 2016 blocks (~2 weeks) to maintain ~10-minute block times." },
      { term: "Digital Signature", definition: "A cryptographic proof of ownership using hashing and encryption of a key pair." },
      { term: "Distributed Ledger", definition: "A database, like Bitcoin’s blockchain, replicated across multiple nodes, ensuring transparency and resilience." },
      { term: "Double Spend", definition: "The risk of spending the same cryptocurrency twice, prevented by blockchain consensus." },
      { term: "Dust", definition: "Very small amounts of Bitcoin (e.g., fractions of a satoshi) that are uneconomical to spend due to high transaction fees." },
      { term: "Dust Attack", definition: "An attack sending tiny Bitcoin amounts to many addresses to de-anonymize users by tracing spending patterns." }
    ]
  },
  {
    id: "letter-e",
    letter: "E",
    terms: [
      { term: "ECDSA", definition: "Elliptic Curve Digital Signature Algorithm, the cryptographic method used in Bitcoin to sign transactions and ensure security." },
      { term: "Encryption", definition: "Converting plaintext into ciphertext to secure data from unauthorized access." },
      { term: "Escrow", definition: "A Bitcoin transaction setup where funds are held by a trusted third party or multisig until conditions are met." },
      { term: "Exchange", definition: "A platform for buying, selling, and trading cryptocurrencies." },
      { term: "Extended Public Key (xPub)", definition: "A key in HD wallets used to generate multiple Bitcoin addresses for monitoring without exposing private keys." }
    ]
  },
  {
    id: "letter-f",
    letter: "F",
    terms: [
      { term: "Fee Market", definition: "The competitive system where Bitcoin users bid higher transaction fees to prioritize confirmation during network congestion." },
      { term: "Fiat Currency", definition: "Government-issued currency like USD or EUR, not backed by a physical commodity, often contrasted with Bitcoin’s decentralized nature." },
      { term: "Fiat On-Ramp", definition: "A service or platform allowing users to purchase Bitcoin using fiat currency, such as through exchanges or ATMs." },
      { term: "FinCEN", definition: "The Financial Crimes Enforcement Network, a US agency regulating virtual currencies like Bitcoin to prevent financial crimes." },
      { term: "Fork", definition: "A protocol change creating two separate blockchain paths. Hard forks are non-compatible; soft forks are backward-compatible." },
      { term: "Full Node", definition: "A Bitcoin node storing the entire blockchain, validating transactions and blocks, and enhancing network security." }
    ]
  },
  {
    id: "letter-g",
    letter: "G",
    terms: [
      { term: "Gas Limit", definition: "A misnomer in Bitcoin; refers to Ethereum’s transaction cost limit, while Bitcoin uses transaction size (bytes) for fees." },
      { term: "Genesis Block", definition: "The first block in the Bitcoin blockchain, containing a reference to a 2009 news headline." }
    ]
  },
  {
    id: "letter-h",
    letter: "H",
    terms: [
      { term: "Halving", definition: "An event every ~4 years where the Bitcoin block reward is halved to control supply." },
      { term: "Hash", definition: "A fixed-length code representing data, used in mining and transaction verification." },
      { term: "Hash Function", definition: "A cryptographic algorithm (e.g., SHA-256) converting input data into a fixed-size output, used in mining and verification." },
      { term: "Hashrate", definition: "The computational power used in Bitcoin mining, measured in hashes per second (e.g., EH/s), indicating network security." },
      { term: "HD Wallet", definition: "A hierarchical deterministic wallet generating all private keys from a single seed phrase, simplifying backups." },
      { term: "HODL", definition: "A term meaning 'Hold On for Dear Life,' encouraging long-term cryptocurrency holding." },
      { term: "Hot Wallet", definition: "An internet-connected Bitcoin wallet, convenient for transactions but more vulnerable to hacks." },
      { term: "Hyperbitcoinization", definition: "The hypothetical point where Bitcoin becomes the dominant global currency." }
    ]
  },
  {
    id: "letter-i",
    letter: "I",
    terms: [
      { term: "ICO", definition: "Initial Coin Offering, a fundraising method for new cryptocurrencies, not Bitcoin, often subject to regulatory scrutiny." },
      { term: "Immutable", definition: "A property of the Bitcoin blockchain where recorded transactions cannot be altered, ensuring data integrity and trust." },
      { term: "Inflation", definition: "The loss of purchasing power in fiat currencies due to excessive money printing, unlike Bitcoin's fixed supply." },
      { term: "Input", definition: "The part of a Bitcoin transaction referencing a previous UTXO to spend funds, signed by the private key." }
    ]
  },
  {
    id: "letter-j",
    letter: "J",
    terms: [
      { term: "JSON-RPC", definition: "A protocol used by Bitcoin nodes to communicate with wallets or applications, enabling blockchain queries." }
    ]
  },
  {
    id: "letter-k",
    letter: "K",
    terms: [
      { term: "Key Pair", definition: "A public key for receiving and a private key for spending cryptocurrencies, cryptographically linked." },
      { term: "KYC", definition: "Know Your Customer, a regulatory requirement for Bitcoin exchanges to verify user identities to prevent fraud and money laundering." },
      { term: "KYC/AML", definition: "Know Your Customer/Anti-Money Laundering, regulations requiring Bitcoin exchanges to verify user identities and monitor transactions." }
    ]
  },
  {
    id: "letter-l",
    letter: "L",
    terms: [
      { term: "Layer-2", definition: "Scaling solutions like the Lightning Network processing Bitcoin transactions off-chain for speed and cost efficiency." },
      { term: "Legal Tender", definition: "Currency recognized by a government for settling debts, e.g., Bitcoin in El Salvador, but treated as property elsewhere." },
      { term: "Light Client", definition: "A Bitcoin wallet or node relying on full nodes for data, not storing the full blockchain, suitable for mobile devices." },
      { term: "Lightning Network", definition: "A layer-2 solution for Bitcoin enabling faster, cheaper off-chain transactions." }
    ]
  },
  {
    id: "letter-m",
    letter: "M",
    terms: [
      { term: "Market Capitalization", definition: "The total value of all mined bitcoins, calculated by multiplying the current price by circulating supply, often over $2 trillion in 2025." },
      { term: "Mempool", definition: "A node’s temporary storage for unconfirmed Bitcoin transactions awaiting miner inclusion in a block." },
      { term: "Merkle Root", definition: "A single hash in a Bitcoin block header summarizing all transaction hashes for efficient verification." },
      { term: "Merkle Tree", definition: "A hierarchical structure organizing transaction hashes into a Merkle root for data integrity in blocks." },
      { term: "Mining", definition: "The process of using computational power to verify transactions and add blocks to the blockchain." },
      { term: "Mining Pool", definition: "A group of miners pooling resources to increase chances of earning block rewards." },
      { term: "Mining Rig", definition: "A computer system with ASICs optimized for Bitcoin mining to maximize hashrate and efficiency." },
      { term: "Multisig", definition: "A security feature requiring multiple private keys to authorize a Bitcoin transaction, enhancing protection." }
    ]
  },
  {
    id: "letter-n",
    letter: "N",
    terms: [
      { term: "Network Difficulty", definition: "The measure of how hard it is to mine a Bitcoin block, adjusted to maintain consistent block times." },
      { term: "NFT", definition: "Non-Fungible Token, a unique digital asset; Bitcoin supports NFTs via Ordinals for collectibles." },
      { term: "Node", definition: "A computer validating transactions and blocks in the Bitcoin network." },
      { term: "Nonce", definition: "A number in a block header adjusted during mining to find a valid proof-of-work." }
    ]
  },
  {
    id: "letter-o",
    letter: "O",
    terms: [
      { term: "OP_CODE", definition: "Operation codes in Bitcoin’s scripting language defining transaction rules like signature verification." },
      { term: "Ordinals", definition: "A protocol inscribing data onto satoshis, enabling NFT-like functionality on Bitcoin." },
      { term: "Orphan Block", definition: "A solved block not accepted by the network, excluded from the blockchain." },
      { term: "Output", definition: "A transaction component specifying satoshis and spending conditions." }
    ]
  },
  {
    id: "letter-p",
    letter: "P",
    terms: [
      { term: "P2P", definition: "Peer-to-Peer transactions without intermediaries." },
      { term: "P2SH Address", definition: "Pay-to-Script-Hash address starting with ‘3,’ enabling complex scripts like multisig for flexibility." },
      { term: "Paper Wallet", definition: "A physical document containing a Bitcoin private key and address, used for offline storage to enhance security." },
      { term: "Payment Channel", definition: "A two-party agreement on the Lightning Network for off-chain Bitcoin transactions, settling net results on-chain." },
      { term: "Phishing", definition: "A scam attempting to steal Bitcoin private keys or seed phrases via fake websites or emails, a common threat to users." },
      { term: "Private Key", definition: "A secret code proving the right to spend bitcoins from a wallet." },
      { term: "Proof of Work", definition: "Bitcoin's consensus mechanism where miners solve puzzles to validate transactions." },
      { term: "Pseudonymity", definition: "Bitcoin’s property where transactions are tied to addresses, not real identities, offering partial privacy." },
      { term: "Public Key", definition: "A code derived from a private key for receiving cryptocurrencies." }
    ]
  },
  {
    id: "letter-q",
    letter: "Q",
    terms: [
      { term: "QR Code", definition: "A scannable image representing Bitcoin addresses or invoices for quick transactions." },
      { term: "Quantum Computing", definition: "Advanced computing that could potentially challenge Bitcoin's cryptographic security." }
    ]
  },
  {
    id: "letter-r",
    letter: "R",
    terms: [
      { term: "Replace-By-Fee (RBF)", definition: "A feature allowing replacement of an unconfirmed transaction with a higher-fee one for faster confirmation." },
      { term: "Replay Attack", definition: "An attack reusing a transaction valid on one chain (e.g., post-fork) on another, mitigated by replay protection." }
    ]
  },
  {
    id: "letter-s",
    letter: "S",
    terms: [
      { term: "Satoshi", definition: "The smallest Bitcoin unit, equal to 0.00000001 BTC." },
      { term: "Satoshi Nakamoto", definition: "The pseudonymous creator of Bitcoin." },
      { term: "Script", definition: "Bitcoin’s programming language defining transaction conditions, such as requiring signatures or multisig." },
      { term: "Seed Phrase", definition: "A mnemonic phrase for generating and recovering cryptocurrency wallets." },
      { term: "SegWit", definition: "Segregated Witness, a Bitcoin update separating signature data to increase block capacity." },
      { term: "SHA-256", definition: "The cryptographic hash function used in Bitcoin’s proof-of-work for mining and verification." },
      { term: "Simplified Payment Verification (SPV)", definition: "A lightweight wallet method verifying transactions using block headers, relying on full nodes." },
      { term: "Smart Contract", definition: "A programmable Bitcoin transaction using scripts for conditions like multisig or time locks." },
      { term: "Soft Fork", definition: "A backward-compatible protocol change that tightens Bitcoin’s rules without creating a new chain, maintaining network consensus." },
      { term: "Stale Block", definition: "A valid block not included in the main chain due to a competing block being accepted first." },
      { term: "Store of Value", definition: "An asset like Bitcoin that maintains or increases value over time, often compared to gold due to its fixed 21 million coin supply." }
    ]
  },
  {
    id: "letter-t",
    letter: "T",
    terms: [
      { term: "Taproot", definition: "A 2021 Bitcoin upgrade enhancing privacy, efficiency, and smart contract capabilities using Schnorr signatures." },
      { term: "Testnet", definition: "A separate Bitcoin network for testing applications with valueless coins, avoiding main chain risks." },
      { term: "Time Lock", definition: "A transaction feature delaying spending until a specified time or block height, used in Lightning Network." },
      { term: "Transaction", definition: "A transfer of value between Bitcoin wallets, recorded on the blockchain." },
      { term: "Transaction Fee", definition: "A fee paid to miners to prioritize transaction inclusion in a block." },
      { term: "TXID", definition: "Transaction ID, a unique hash identifying a Bitcoin transaction on the blockchain." }
    ]
  },
  {
    id: "letter-u",
    letter: "U",
    terms: [
      { term: "Unconfirmed Transaction", definition: "A Bitcoin transaction in the mempool, not yet included in a block by miners." },
      { term: "UTXO", definition: "Unspent Transaction Output, representing unspent value in Bitcoin." }
    ]
  },
  {
    id: "letter-v",
    letter: "V",
    terms: [
      { term: "Vault", definition: "A highly secure Bitcoin storage solution using multisig and time locks for long-term or institutional custody." },
      { term: "Volatility", definition: "The price fluctuation of Bitcoin, typical of cryptocurrencies." }
    ]
  },
  {
    id: "letter-w",
    letter: "W",
    terms: [
      { term: "Wallet", definition: "Software or hardware storing private keys for managing cryptocurrencies." },
      { term: "Watch-Only Wallet", definition: "A wallet tracking Bitcoin addresses without private keys, used for secure monitoring." },
      { term: "Whitepaper", definition: "The document by Satoshi Nakamoto outlining Bitcoin's design." },
      { term: "Wrapped Bitcoin (WBTC)", definition: "A token on Ethereum pegged 1:1 to Bitcoin, enabling its use in DeFi ecosystems." }
    ]
  },
  {
    id: "letter-x",
    letter: "X",
    terms: [
      { term: "XPub", definition: "Extended Public Key in HD wallets, generating multiple addresses for monitoring without private keys." }
    ]
  },
  {
    id: "letter-z",
    letter: "Z",
    terms: [
      { term: "Zero Confirmation", definition: "A transaction broadcast but not yet confirmed by miners." },
      { term: "Zero-Knowledge Proof", definition: "A cryptographic method to prove a statement without revealing extra information." }
    ]
  },
  {
    id: "letter-numbers",
    letter: "Numbers",
    terms: [
      { term: "2FA", definition: "Two-Factor Authentication, an extra security layer for Bitcoin wallets requiring a second verification step." },
      { term: "51% Attack", definition: "An attack where an entity controls over 50% of Bitcoin’s hashrate, potentially enabling double-spending." }
    ]
  }
];

document.dispatchEvent(new Event('glossaryLoaded'));